import React from 'react';
import { Pagination, PaginationItem } from '@mui/material';

import { FORTA_BLUE } from '../../utils/colors';

import type { PaginationProps } from '@mui/material';

interface FHPaginationProps extends PaginationProps {
  currentPage: number;
  handlePageChange: (event: React.ChangeEvent<unknown>, value: number) => void;
}

const FHPagination: React.FC<FHPaginationProps> = ({
  count,
  currentPage,
  handlePageChange,
  ...props
}) => {
  return (
    <Pagination
      count={count}
      page={currentPage}
      onChange={handlePageChange}
      color="primary"
      renderItem={(item) => (
        <PaginationItem
          component="div"
          sx={{
            '&.Mui-selected': {
              backgroundColor: 'transparent',
              color: FORTA_BLUE.primary,
              textDecoration: 'underline',
              fontWeight: 700,
            },
            '&.Mui-selected:hover': {
              backgroundColor: 'transparent',
              color: FORTA_BLUE.primary,
            },
          }}
          {...item}
        />
      )}
      {...props}
    />
  );
};

export default FHPagination;
